// src/components/WalletSecurity/WalletRecovery.jsx
// Recuperación de wallet — cierra la promesa del onboarding ("si perdés el teléfono,
// la recuperás"). Deja al usuario configurar SU recuperación (passcode, Google Drive,
// iCloud…) en vez de depender del escrow de Privy. Cuanto más controla el usuario su
// recuperación, más autocustodio es (sin frase semilla que memorizar).
//
// Solo aplica a wallets EMBEBIDAS. Render nulo si no hay. Se monta solo con
// REACT_APP_PRIVY_APP_ID (lo decide el caller).
import React, { useState } from 'react';
import { usePrivy, useWallets, useSetWalletRecovery } from '@privy-io/react-auth';
import { FiLifeBuoy, FiCheckCircle, FiAlertCircle } from 'react-icons/fi';
import './WalletRecovery.css';

// Nombres en humano de los métodos de recuperación de Privy.
const METHOD_LABEL = {
  'user-passcode': 'Contraseña de recuperación',
  'google-drive':  'Google Drive',
  'icloud':        'iCloud',
  'icloud-native': 'iCloud',
  'passkey':       'Passkey (huella / Face ID)',
};

export default function WalletRecovery() {
  const { user, ready } = usePrivy();
  const { wallets } = useWallets();
  const { setWalletRecovery } = useSetWalletRecovery();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const embedded = (wallets || []).find(w => w.walletClientType === 'privy');
  if (!embedded) return null;

  // Estado de recuperación: lo trae la cuenta de wallet enlazada al usuario.
  const account = (user?.linkedAccounts || []).find(
    a => a.type === 'wallet'
      && a.walletClientType === 'privy'
      && a.address?.toLowerCase() === embedded.address.toLowerCase()
  );
  const method = account?.recoveryMethod;
  // 'privy' (o sin método) = la maneja Privy; cualquier otro = recuperación propia del usuario.
  const userSecured = !!method && method !== 'privy';

  const handleSet = async () => {
    setError('');
    setBusy(true);
    try {
      await setWalletRecovery();
    } catch (e) {
      setError(e?.message || 'No se pudo abrir la configuración de recuperación.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="wr">
      <div className="wr-head">
        <span className="wr-ic"><FiLifeBuoy /></span>
        <div>
          <h3 className="wr-title">Recuperación de tu wallet</h3>
          <p className="wr-sub">
            Si perdés el teléfono, así volvés a entrar — <strong>sin frases de 12 palabras que memorizar</strong>.
            Configurar tu propia recuperación te da control total: ni Bitplify ni Privy deciden por vos.
          </p>
        </div>
      </div>

      <div className={`wr-status ${userSecured ? 'ok' : 'pending'}`}>
        {userSecured ? (
          <>
            <FiCheckCircle className="wr-status-ic" />
            <span>Recuperación activa — <strong>{METHOD_LABEL[method] || 'método propio'}</strong>.</span>
          </>
        ) : (
          <>
            <FiAlertCircle className="wr-status-ic" />
            <span>Todavía no configuraste tu recuperación. Hacelo ahora para no depender de nadie más.</span>
          </>
        )}
      </div>

      <button type="button" className="wr-btn" onClick={handleSet} disabled={!ready || busy}>
        {busy ? 'Abriendo…' : userSecured ? 'Cambiar método de recuperación' : 'Configurar recuperación'}
      </button>

      {error && <div className="wr-error">{error}</div>}
    </div>
  );
}
